export abstract class BaseModal {
    public abstract data: any; // Data supplied to this modal is put in this property by the modal component when it injects it

    /**
     * A method that is added from the modal component and which closes the modal. This is called whenever the modal needs to close for whatever reason.
     * @param {Object} data
     */
    public closeModalInstance(data?: any): void {}
}
